
import { Component, Prop, Vue } from 'vue-property-decorator'

import * as Common from '@/api/common'
import { getVal, isEmpty } from '@/utils/helpers'

@Component
export default class UnsolvedReason extends Vue {
    @Prop()
    private commonInfo!: any

    readonly labelCol = { span: 4 }
    readonly wrapperCol = { span: 20 }

    visible = false
    loading = false

    form = {
      reasonType: undefined,
      reasonText: ''
    }

    dataList: any = []

    show (channelId: string, knowledgeId: string) {
      Common.queryUnSatisList(channelId, knowledgeId).then((res: any) => {
        this.dataList = getVal(res, 'questionnaire', []).filter((obj: any) => {
          return !isEmpty(obj.text)
        })
        this.visible = true
      }).catch(() => {
        this.dataList = []
        this.visible = true
      })
    }

    handleCancel() {
      this.visible = false
    }

    handleSubmit() {
      if (isEmpty(this.form.reasonType) && isEmpty(this.form.reasonText)) {
        this.$message.warn('请选择原因')
        return
      }

      

      const reason = getVal(this, 'form.reasonType', this.form.reasonText.trim())
      this.loading = true
      const params = {
          answerTime: this.commonInfo.answerStamp,
          channelId: this.commonInfo.channelId,
          knowledgeId: this.commonInfo.knowledgeId,
          talkId: this.commonInfo.talkId,
          questionnaire: reason
        }
        Common.saveUnsolvedReason(params).then(res => {
          this.$message.success('感谢您的反馈')
          this.visible = false
          this.$emit('success')
        }).catch(err => {
          this.$message.error(err.message)
        }).finally(() => {
          this.loading = false
        })
    }

    afterClose() {
      this.form = {
        reasonType: undefined,
        reasonText: ''
      }
    }
}
